<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed, onMounted, ref } from 'vue';
import type { Employment } from '@sysarb/sysarb-types/services/v1/employment';

type ExtendedParams = ICellRendererParams<Employment, void> & {
    number: (params: ICellRendererParams) => number;
    string: (params: ICellRendererParams) => string;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const paramsNumber = computed(() => (typeof props.params.number === 'function' ? props.params.number(props.params) : props.params.number));
const paramsString = computed(() => (typeof props.params.string === 'function' ? props.params.string(props.params) : props.params.string));
const count = computed(() => {
    if (Array.isArray(props.params.value)) {
        return props.params.value.length;
    }

    return 0;
});
const valueFromParams = ref();

onMounted(() => {
    if (paramsNumber.value) {
        valueFromParams.value = paramsNumber.value;
        return valueFromParams.value;
    }
    if (paramsString.value) {
        valueFromParams.value = paramsString.value;
        return valueFromParams.value;
    }
    return '';
});

</script>

<template>
    <div class="flex-container align-middle height-100">
        <span class="margin-right-2">{{ valueFromParams }}</span>
        <p class="sy-type-italic sy-type-gray-light">{{ count > 1 ? `+${count - 1}` : '' }}</p>
    </div>
</template>
